<template>
  <v-app>
    <div class="flex-row">
      <div class="float-right pt-3 pr-3" align="right">
        <v-btn
          class="btn-text"
          fab
          small
          outlined
          @click="switchLocale($i18n.locale)"
        >
          {{ $i18n.locale == "en" ? "fr" : "en" }}
        </v-btn>
      </div>
    </div>

    <v-main class="d-flex align-center justify-center">
      <v-row justify="center">
        <v-col align="center" cols="12" sm="10" md="8" lg="6" xl="6">
          <v-container class="py-5 fill-height" v-show="apiDone">
            <v-img
              src="@/assets/img/company-logo/TFF_StackedLogo_BIL.png"
              alt="Terry Fox Foundation logo"
              contain
              height="100"
              class="mb-5"
              @load="onImgLoad()"
            >
            </v-img>

            <v-row justify="center">
              <div v-show="imgLoaded">
                <!-- <div placeholder="{{ 'Loading' | translate }}"></div> -->
                <p>{{ $t(["Loading"]) }}</p>

                <v-progress-circular
                  :size="40"
                  color="secondary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <Form @apiComplete="apiComplete()" />
    </v-main>
  </v-app>
</template>

<script>
import Form from "./components/Form.vue";

export default {
  name: "App",
  data: () => ({
    apiDone: true,
    imgLoaded: false,
  }),
  components: {
    Form,
  },
  methods: {
    switchLocale(locale) {
      if (locale == "en") {
        this.$i18n.locale = "fr";
      } else if (locale == "fr") {
        this.$i18n.locale = "en";
      }
    },
    apiComplete() {
      this.apiDone = false;
    },
    onImgLoad() {
      this.imgLoaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Gibson";
  src: local("Gibson"),
    url("../src/assets/fonts/Gibson-Regular.ttf") format("truetype");
}

#app {
  font-family: "Gibson", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
